module.exports = __webpack_public_path__ + "assets/img/services6.3cc7092c.svg";